import ITitles from '../../shared/interfaces/titles.interface';

export const TITLE_BRANCH_COMMENTS: ITitles = {
    icon: 'comments',
    title: 'Comentarios',
    description: '',
}